import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function presentationReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_LOADING:
    case TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_LOADING:
    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_LOADING:
    case TYPE.PRESENTATION.INSERT_PRESENTATION_LOADING:
    case TYPE.PRESENTATION.UPDATE_PRESENTATION_LOADING:
    case TYPE.PRESENTATION.DELETE_PRESENTATION_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.PRESENTATION.ACCEPT_PRESENTATION_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_FAILURE:
    case TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_FAILURE:
    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_FAILURE:
    case TYPE.PRESENTATION.INSERT_PRESENTATION_FAILURE:
    case TYPE.PRESENTATION.UPDATE_PRESENTATION_FAILURE:
    case TYPE.PRESENTATION.DELETE_PRESENTATION_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.PRESENTATION.ACCEPT_PRESENTATION_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_SUCCESS:
      return state.merge({
        list: action.payload || [],
        isFetching: false,
      });

    case TYPE.PRESENTATION.GET_FILTERED_PRESENTATION_SUCCESS:
      return state.merge({
        listFiltered: action.payload || [],
        isFetching: false,
      });

    case TYPE.PRESENTATION.GET_ALL_PRESENTATION_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        listById: [...action.payload],
        isFetching: false,
      });

    case TYPE.PRESENTATION.INSERT_PRESENTATION_SUCCESS: {
      const newlistById = state.get("listById");
      const index = action.payload.presentationProfile.findIndex((e) => e.profileId === action.id);
      if (index >= 0) newlistById.push({ presentation: action.payload });
      return state.merge({
        listById: [...newlistById],
        listFiltered: [...state.get("listFiltered"), { presentation: action.payload }],
        isFetching: false,
      });
    }

    case TYPE.PRESENTATION.UPDATE_PRESENTATION_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.presentation.id === action.id);
      newList.splice(index, 1, { presentation: action.payload });

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.presentation.id === action.id);
      newList1.splice(index1, 1, { presentation: action.payload });

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.PRESENTATION.DELETE_PRESENTATION_SUCCESS: {
      const newList = state.get("listFiltered");
      const index = newList.findIndex((e) => e.presentation.id === action.id);
      if (index !== -1) newList.splice(index, 1);

      const newList1 = state.get("listById");
      const index1 = newList1.findIndex((e) => e.presentation.id === action.id);
      if (index1 !== -1) newList1.splice(index1, 1);

      return state.merge({
        listFiltered: [...newList],
        listById: [...newList1],
        isFetching: false,
      });
    }

    case TYPE.PRESENTATION.ACCEPT_PRESENTATION_SUCCESS: {
      const newList = state.get("listById");
      const index = newList.findIndex((e) => e.presentation.id === action.payload.id);
      const newPresentation = { ...newList[index], presentation: action.payload };
      newList.splice(index, 1, newPresentation);

      const newList1 = state.get("listFiltered");
      const index1 = newList1.findIndex((e) => e.presentation.id === action.payload.id);
      const newPresentation1 = { ...newList1[index1], presentation: action.payload };
      newList1.splice(index1, 1, newPresentation1);

      return state.merge({
        listById: [...newList],
        listFiltered: [...newList1],
        isFetchingAccepted: false,
      });
    }

    default:
      return state;
  }
}

